<template>
  <img
    :src="windowWidth < smallScreenWidth ? '/image/logo.png' : '/image/logo_vce.png'"
    width="53px"
    alt=""
    v-once
    v-if="windowWidth !== null"
    class="mr-20"
  />
</template>
<script>
export default {
  setup() {
    const smallScreenWidth = 360;
    const windowWidth = window.innerWidth;

    return {
      windowWidth,
      smallScreenWidth,
    };
  },
};
</script>
